import { BasicProps } from "components/types/BasicProps";
import { FC } from "react";
import { PiWarningFill } from "react-icons/pi";
import { earnLiterals } from "./literals";
import classNames from "classnames";

type Props = BasicProps & {
  nonActiveCurrencies: string[];
};

const { message } = earnLiterals.vaultWarningToast;

export const VaultWarningToast: FC<Props> = (props) => {
  const { className, nonActiveCurrencies } = props;

  return (
    <div
      className={classNames(
        "w-[900px] border-2 border-[#5B90F8] rounded-[20px] bg-secondary py-[26px] flex items-center justify-center gap-[15px]",
        className
      )}
    >
      <PiWarningFill className="w-12 h-12 text-[#5B90F8] text-[30px]" />
      <span className="w-[630px]">{message(nonActiveCurrencies)}</span>
    </div>
  );
};
